export const getError = state => state.uploadFile.get('error')
export const getIsSubmitting = state => state.uploadFile.get('isSubmitting')
